import ReactQuill from "react-quill";
import { quillFormats, quillModules } from "../../helper/quotation";

const TaxSummary = ({
    data,
    handleChange,
    taxSummary,
    taxType,
    showTerms = true,
    termsLabel = "Terms and Conditions",
    taxLabel = "Tax Summary",
    termsFieldName = "terms_and_cond",
    totalQuantityField = "total_quantity",
    isReceiveLoading = true
}) => {
    return (
        <>
            <div className="row mt-3">
                {showTerms && (
                    <div className="col-12 col-md-7 col-xl-8">
                        <div
                            className="card shadow-sm h-100"
                            style={{ border: "1px solid #e0e0e0" }}
                        >
                            <div
                                className="card-header"
                                style={{
                                    backgroundColor: "rgba(255, 105, 35, 0.1)",
                                    border: "1px solid var(--primary-clr)",
                                    color: "var(--primary-clr)",
                                }}
                            >
                                <h6
                                    className="mb-0 fw-semibold"
                                    style={{ color: "var(--primary-clr)", fontSize: "15px" }}
                                >
                                    <i
                                        className="fa fa-file-text me-2"
                                        style={{ color: "var(--primary-clr)" }}
                                    ></i>
                                    {termsLabel}
                                </h6>
                            </div>

                            <div
                                className="card-body p-0 terms-editor-wrapper"
                                style={{ height: "", overflow: "hidden" }}
                            >
                                <ReactQuill
                                    theme="snow"
                                    value={
                                        data[termsFieldName]?.trim()
                                            ? data[termsFieldName]
                                            : "Thanks for doing business with us!"
                                    }
                                    onChange={(value) =>
                                        handleChange(null, termsFieldName, value)
                                    }
                                    modules={quillModules}
                                    formats={quillFormats}
                                    style={{ height: "370px" }}
                                />
                            </div>
                        </div>
                    </div>
                )}

                <div className={showTerms ? "col-12 col-md-5 col-xl-4" : "col-12 col-md-6 col-lg-6 col-xl-4 ms-auto"}>
                    <div
                        className="card shadow-sm h-100"
                        style={{ border: "1px solid #e0e0e0" }}
                    >
                        <div
                            className="card-header"
                            style={{
                                background:
                                    "linear-gradient(135deg, var(--primary-clr) 0%, #ff8c42 100%)",
                                color: "white",
                                padding: "14px 20px",
                                borderRadius: "0.25rem 0.25rem 0 0",
                            }}
                        >
                            <h6
                                className="mb-0 fw-semibold"
                                style={{
                                    fontSize: "15px",
                                    color: "#fff",
                                    letterSpacing: "0.3px",
                                }}
                            >
                                <i className="fa fa-calculator me-2"></i>
                                {taxLabel}
                            </h6>
                        </div>
                        <div className="card-body" style={{ padding: "20px" }}>
                            <div
                                className="mb-3 pb-3"
                                style={{ borderBottom: "1px solid #e9ecef" }}
                            >
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <span style={{ color: "#6c757d", fontSize: "14px" }}>
                                        Amount
                                    </span>
                                    <span
                                        className="fw-semibold"
                                        style={{ color: "#2c3e50", fontSize: "15px" }}
                                    >
                                        ₹ {taxSummary.grossAmount?.toFixed(2) || taxSummary.subtotal?.toFixed(2)}
                                    </span>
                                </div>
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <span style={{ color: "#6c757d", fontSize: "14px" }}>
                                        Total Discount
                                    </span>
                                    <span
                                        className="fw-semibold"
                                        style={{ color: "#2c3e50", fontSize: "15px" }}
                                    >
                                        - ₹ {taxSummary.discountAmount?.toFixed(2) || "0.00"}
                                    </span>
                                </div>
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <span style={{ color: "#6c757d", fontSize: "14px" }}>
                                        Taxable Amount
                                    </span>
                                    <span
                                        className="fw-semibold"
                                        style={{ color: "#2c3e50", fontSize: "15px" }}
                                    >
                                        ₹ {taxSummary.taxableAmount?.toFixed(2) || "0.00"}
                                    </span>
                                </div>
                                <div className="d-flex justify-content-between align-items-center">
                                    <span style={{ color: "#6c757d", fontSize: "14px" }}>
                                        Total Quantity
                                    </span>
                                    <span
                                        className="fw-semibold"
                                        style={{ color: "#2c3e50", fontSize: "15px" }}
                                    >
                                        {data[totalQuantityField]?.toFixed(2)}
                                    </span>
                                </div>
                            </div>

                            <div
                                className="mb-3 pb-3"
                                style={{ borderBottom: "1px solid #e9ecef" }}
                            >
                                <div className="mb-2">
                                    <span
                                        className="fw-semibold"
                                        style={{ color: "var(--primary-clr)", fontSize: "14px" }}
                                    >
                                        Tax Breakdown
                                    </span>
                                </div>
                                {taxType === "cgst_sgst" ? (
                                    <>
                                        <div className="d-flex justify-content-between align-items-center mb-2 ms-1">
                                            <span style={{ color: "#6c757d", fontSize: "13px" }}>
                                                CGST
                                            </span>
                                            <span style={{ color: "#2c3e50", fontSize: "14px" }}>
                                                ₹ {taxSummary.cgst.toFixed(2)}
                                            </span>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center ms-1">
                                            <span style={{ color: "#6c757d", fontSize: "13px" }}>
                                                SGST
                                            </span>
                                            <span style={{ color: "#2c3e50", fontSize: "14px" }}>
                                                ₹ {taxSummary.sgst.toFixed(2)}
                                            </span>
                                        </div>
                                    </>
                                ) : (
                                    <div className="d-flex justify-content-between align-items-center ms-1">
                                        <span style={{ color: "#6c757d", fontSize: "13px" }}>
                                            GST
                                        </span>
                                        <span style={{ color: "#2c3e50", fontSize: "14px" }}>
                                            ₹ {(taxSummary.igst || taxSummary.taxAmount).toFixed(2)}
                                        </span>
                                    </div>
                                )}
                            </div>

                            <div className="mb-2">
                                <span
                                    className="fw-semibold"
                                    style={{ color: "gray", fontSize: "14px" }}
                                >
                                    Other Expenses
                                </span>
                            </div>

                            <div className="d-flex justify-content-between align-items-center mb-2">
                                {/* loading with GST (18%) */}
                                {isReceiveLoading ? (
                                    <>
                                        <span style={{ color: "#6c757d", fontSize: "14px" }}>
                                            Loading Amount (18%)
                                        </span>
                                        <span style={{ color: "#2c3e50", fontSize: "14px" }}>
                                            ₹ {(parseFloat(taxSummary.loading_amount || 0) * 1.18).toFixed(2)}
                                        </span>
                                    </>
                                ) : ""}
                            </div>

                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <span style={{ color: "#6c757d", fontSize: "14px" }}>
                                    Freight Amount (18%)
                                </span>
                                <span style={{ color: "#2c3e50", fontSize: "14px" }}>
                                    ₹ {(parseFloat(taxSummary.freight_amount || 0) * 1.18).toFixed(2)}
                                </span>
                            </div>

                            <div
                                className="mb-3 pb-3"
                                style={{ borderBottom: "1px solid #e9ecef" }}
                            >
                                <div className="d-flex justify-content-between align-items-center">
                                    <span style={{ color: "#6c757d", fontSize: "14px" }}>
                                        Round Off
                                    </span>
                                    <span style={{ color: "#2c3e50", fontSize: "14px" }}>
                                        {taxSummary.roundOff >= 0 ? "+" : ""} ₹{" "}
                                        {taxSummary.roundOff.toFixed(2)}
                                    </span>
                                </div>
                            </div>

                            <div
                                className="p-3 rounded"
                                style={{
                                    background:
                                        "linear-gradient(135deg, rgba(255, 105, 35, 0.1) 0%, rgba(255, 140, 66, 0.1) 100%)",
                                    border: "1px solid var(--primary-clr)",
                                }}
                            >
                                <div className="d-flex justify-content-between align-items-center">
                                    <span
                                        className="fw-bold"
                                        style={{ color: "var(--primary-clr)", fontSize: "16px" }}
                                    >
                                        Total Amount
                                    </span>
                                    <span
                                        className="fw-bold"
                                        style={{ color: "var(--primary-clr)", fontSize: "18px" }}
                                    >
                                        ₹ {taxSummary.total.toFixed(2)}
                                    </span>
                                </div>
                            </div>

                            {/* <div
                                className="mt-3 p-2 rounded text-center"
                                style={{
                                    backgroundColor: "#f8f9fa",
                                    border: "1px dashed var(--primary-clr)",
                                }}
                            >
                                <small
                                    style={{
                                        color: "var(--primary-clr)",
                                        fontSize: "12px",
                                        fontWeight: "500",
                                    }}
                                >
                                    <i className="fa fa-info-circle me-1"></i>
                                    Tax Type: {taxType === "cgst_sgst" ? "CGST + SGST" : "IGST"}
                                </small>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default TaxSummary;
